import { showNotification } from '@helpers/notification-helper';
import { removeMedicalRecord } from '@services/external/medicalRecords.api';
import { Modal } from '@ui';
import React from 'react';
import { IMedicalRecord } from 'types/medicalRecord.types';

interface MedicalRecordDeleteProps {
  visible: boolean;
  onClose?: () => void;
  afterSubmit?: () => void;
  item?: IMedicalRecord;
  clientId: string;
  providerId: string;
}

const MedicalRecordDelete: React.FunctionComponent<MedicalRecordDeleteProps> = ({
  visible,
  afterSubmit,
  item,
  onClose,
  clientId,
  providerId,
}) => {
  const [submitting, setSubmitting] = React.useState(false);
  const handleSubmit = React.useCallback(async () => {
    if (!item) {
      return;
    }

    try {
      setSubmitting(true);
      await removeMedicalRecord(providerId, clientId, item.id);
      afterSubmit?.();
      onClose?.();
    } catch (error) {
      console.log('MedicalRecordDelete', error);

      showNotification({
        type: 'ERROR',
        title: 'Niečo sa pokazilo',
        copy: '',
      });
    } finally {
      setSubmitting(false);
    }
  }, [item?.id, clientId, providerId]);

  return (
    <Modal
      title="Odstránenie záznamu"
      visible={visible}
      onClose={onClose}
      footer={
        <Modal.Actions
          actions={[
            { key: 'cancel', label: 'zrušiť', onClick: onClose, variant: 'ghost' },
            {
              key: 'submit',
              label: 'Odstrániť',
              onClick: handleSubmit,
              variant: 'danger',
              loading: submitting,
            },
          ]}
        />
      }
    >
      <Modal.Title>
        Odstránenie záznamu: <strong>{item?.name}</strong>
      </Modal.Title>
      <Modal.Description>Naozaj chcete odstrániť záznam?</Modal.Description>
    </Modal>
  );
};

export default MedicalRecordDelete;
